/**
 * Mobile sticky cart checkout: show when main #checkout leaves viewport.
 */
(function () {
  if (window.__dunteryStickyCartCheckoutBound) return;
  window.__dunteryStickyCartCheckoutBound = true;

  var MOBILE_MQ = '(max-width: 749px)';
  var intersectionObserver = null;

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function getSticky() {
    return document.querySelector('[data-sticky-cart-checkout]');
  }

  function getMainButton() {
    return document.getElementById('checkout');
  }

  function setChatOffset(active) {
    var offset = 'calc(9.6rem + env(safe-area-inset-bottom, 0px))';
    var nodes = document.querySelectorAll(
      '#dummy-chat-button-iframe, #ShopifyChat, #shopify-chat, .shopify-chat, iframe[title*="Chat"], iframe[title*="chat"]'
    );
    nodes.forEach(function (el) {
      if (active) {
        el.style.setProperty('bottom', offset, 'important');
      } else {
        el.style.removeProperty('bottom');
      }
    });
  }

  function setVisible(sticky, visible) {
    if (!sticky) return;
    var footer = document.getElementById('main-cart-footer');
    var empty = footer && footer.classList.contains('is-empty');

    if (!isMobile() || empty) {
      sticky.hidden = true;
      document.documentElement.classList.remove('is-sticky-cart-checkout-visible');
      setChatOffset(false);
      return;
    }

    sticky.hidden = !visible;
    document.documentElement.classList.toggle('is-sticky-cart-checkout-visible', visible);
    setChatOffset(visible);
  }

  function syncButtonState() {
    var sticky = getSticky();
    var main = getMainButton();
    if (!sticky || !main) return;

    var submit = sticky.querySelector('[data-sticky-cart-checkout-submit]');
    if (!submit) return;

    var disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
    if (submit.disabled !== disabled) {
      submit.disabled = disabled;
    }
  }

  function bindObserver() {
    if (intersectionObserver) {
      intersectionObserver.disconnect();
      intersectionObserver = null;
    }

    var sticky = getSticky();
    var main = getMainButton();
    if (!sticky || !main) return;

    if (!isMobile()) {
      setVisible(sticky, false);
      return;
    }

    intersectionObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry) return;
        setVisible(sticky, !entry.isIntersecting);
        syncButtonState();
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px -8px 0px'
      }
    );

    intersectionObserver.observe(main);
    syncButtonState();
  }

  function onStickyClick(event) {
    var btn = event.target.closest('[data-sticky-cart-checkout-submit]');
    if (!btn) return;
    event.preventDefault();
    var main = getMainButton();
    if (!main || main.disabled) return;
    main.click();
  }

  document.addEventListener('click', onStickyClick);

  window.addEventListener('resize', function () {
    bindObserver();
  });

  window.dunterySyncStickyCartCheckout = function () {
    syncButtonState();
    bindObserver();
  };

  function boot() {
    bindObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
